import DataTablePagination from './DataTablePagination';

export default DataTablePagination;
